import { useMemo } from "react"
import { CopyButton } from "components/Common/CopyButton"
import { generateStockText } from "helpers/stock_helpers"
import formatMileage from "utils/formatMileage"

const StockModelCell = ({ stock, isMobile, toggleRow, isExpanded, rowId }) => {
  const expanded = isExpanded(rowId)

  const textToCopy = useMemo(
    () => generateStockText(stock),
    [stock]
  )

  return (
    <div
      className="text-wrap"
      style={{
        maxWidth: "500px",
        minWidth: "8rem",
        whiteSpace: "normal",
        overflowWrap: "break-word",
      }}
    >
      <div className="d-flex flex-wrap gap-1">
        <div className="fw-bold">
          {stock.brand?.name ?? "-"} {stock.model?.name ?? "-"}{" "}
          {stock.engine_type?.name ?? "-"}
        </div>

        <div className="d-flex gap-1">
          <CopyButton text={textToCopy} />
          {isMobile && (
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => toggleRow(rowId)}
            >
              {expanded ? "▼" : "▶"}
            </button>
          )}
        </div>
      </div>

      {(expanded || !isMobile) && (
        <div className="text-muted d-block mt-1">
          Package: <span className="badge bg-light text-dark">{stock.package?.name ?? "-"}</span>{" "}
          • Year: <span className="badge bg-light text-dark">{stock.year?.name ?? "-"}</span>{" "}
          • Engine CC: <span className="badge bg-light text-dark">{stock.engine_c_c?.name ?? "-"}</span>{" "}
          • Transmission: <span className="badge bg-light text-dark">{stock.transmission?.name ?? "-"}</span>{" "}
          • Fuel: <span className="badge bg-light text-dark">{stock.fuel_type?.name ?? "-"}</span>{" "}
          • Key: <span className="badge bg-light text-dark">{stock.key_type?.name ?? "-"}</span>{" "}
          • Exterior: <span className="badge bg-light text-dark">{stock.exterior_color?.name ?? "-"}</span>{" "}
          • Interior: <span className="badge bg-light text-dark">{stock.interior_color?.name ?? "-"}</span>{" "}
          • Auction Grade: <span className="badge bg-warning">{stock.auction_grade?.name ?? "-"}</span>{" "}
          • Mileage: <span className="badge bg-light text-dark">{formatMileage(stock.mileage)}</span>{" "}
          • Doors: <span className="badge bg-light text-dark">{stock.doors}</span>{" "}
          • Seats: <span className="badge bg-light text-dark">{stock.seats}</span>{" "}
          • Tire: <span className="badge bg-light text-dark">{stock.tire_size ?? "-"}</span>
        </div>
      )}
    </div>
  )
}

export default StockModelCell
